module.exports = __webpack_public_path__ + "media/images/Tiled-Church-montage-0f881105d61aa0ecb7da9c40a9ec5157.png";